


















































































































































































































import useMessagingFilters from "@/composables/useMessagingFilters";
import { useChatsStore } from "@/store/useChatsStore";
import { Team } from "@/types/team.types";
import { User } from "@/types/user.types";
import { resolvePlatformIconSvgSrc, resolvePriorityVariant } from "@/utils/channels";
import { resolveEntryIcon, resolveRemainingCustomerCareWindow } from "@/utils/chats";
import { textColorByBackgroundColor } from "@/utils/color";
import { resolveInitials, resolveUserStatus } from "@/utils/users";
import { localeTimeAgo } from "@/utils/v3/timeAgo.util";
import { ChatChannel, ChatContact, CustomerCareWindow } from "@/views/modules/messaging-inbox/useChat";
import useChatsListContextMenu from "@/views/modules/messaging-inbox/useChatsListContextMenu";
import { ChatsListChat } from "@saysimple-platform/dtos";
import { computed, defineComponent, PropType } from "@vue/composition-api";
import { BAvatar, BBadge, BImg, BSpinner, VBTooltip } from "bootstrap-vue";

export default defineComponent({
    components: {
        BAvatar,
        BBadge,
        BImg,
        BSpinner,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        chat: {
            type: Object as PropType<ChatsListChat>,
        },
        contact: {
            type: Object as PropType<ChatContact>,
        },
        channel: {
            type: Object as PropType<ChatChannel>,
        },
        assignedTeam: {
            type: Object as PropType<Team>,
        },
        assignedUser: {
            type: Object as PropType<User>,
        },
        hasStoredMessage: {
            type: Boolean,
        },
        isUpdatingChat: {
            type: Boolean,
        },
        currentlyTypingNames: {
            type: String,
        },
        currentlyTypingCount: {
            type: Number,
        },
    },
    setup(props) {
        const { getActiveFilter: activeFilter } = useMessagingFilters();

        const chatsStore = useChatsStore();

        const timeAgo = localeTimeAgo(props.chat?.lastMessageEntryTime);

        const customerCareWindow = computed(
            (): CustomerCareWindow =>
                resolveRemainingCustomerCareWindow(
                    props.chat?.lastInboundMessageTime,
                    props.channel?.customerCareWindowLength
                )
        );

        const { showContextMenu } = useChatsListContextMenu();
        return {
            showContextMenu,
            activeFilter,
            chatsStore,
            customerCareWindow,
            resolveEntryIcon,
            resolveInitials,
            resolvePlatformIconSvgSrc,
            resolvePriorityVariant,
            resolveUserStatus,
            textColorByBackgroundColor,
            timeAgo,
        };
    },
});
